// extracted by mini-css-extract-plugin
export default {"recipeList":"Gb565ed","recipeListText":"Gc9fe79","item":"G6d2058"};